module.exports = __webpack_public_path__ + "static/media/infoIcon.7cc53df0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/infoIcon.svg
// module id = 896
// module chunks = 1